/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Other_EyebrowInputs */

const en_endpoint_other_eyebrow = /** @type {(inputs: Endpoint_Other_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More to call`)
};

const zh_hans1_endpoint_other_eyebrow = /** @type {(inputs: Endpoint_Other_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更多接口`)
};

const pt_br2_endpoint_other_eyebrow = /** @type {(inputs: Endpoint_Other_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais para chamar`)
};

const es_endpoint_other_eyebrow = /** @type {(inputs: Endpoint_Other_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más para llamar`)
};

const fr_endpoint_other_eyebrow = /** @type {(inputs: Endpoint_Other_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À appeler aussi`)
};

const de_endpoint_other_eyebrow = /** @type {(inputs: Endpoint_Other_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr zum Aufrufen`)
};

const ru_endpoint_other_eyebrow = /** @type {(inputs: Endpoint_Other_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ещё для вызова`)
};

const it_endpoint_other_eyebrow = /** @type {(inputs: Endpoint_Other_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altro da chiamare`)
};

/**
* | output |
* | --- |
* | "More to call" |
*
* @param {Endpoint_Other_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_other_eyebrow = /** @type {((inputs?: Endpoint_Other_EyebrowInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Other_EyebrowInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_other_eyebrow(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_other_eyebrow(inputs)
	if (locale === "es") return es_endpoint_other_eyebrow(inputs)
	if (locale === "fr") return fr_endpoint_other_eyebrow(inputs)
	if (locale === "de") return de_endpoint_other_eyebrow(inputs)
	if (locale === "ru") return ru_endpoint_other_eyebrow(inputs)
	if (locale === "it") return it_endpoint_other_eyebrow(inputs)
	return en_endpoint_other_eyebrow(inputs)
});